<template>

<div class="main dealer-map">
    <div class="filters">
        <h3>Dealer Map</h3>
        <div class="divider"></div>

        <div class="sidebar-with-stat" @click="setList('all')"><div><span class="legend all"></span>All</div><span class="sidebar-stat">{{ totals.all }}</span><div class="selected" v-if="filters.list == 'all'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('full_cds')"><div><span class="legend full_cds"></span>CDS Dealer</div><span class="sidebar-stat">{{ totals.full_cds }}</span><div class="selected" v-if="filters.list == 'full_cds'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('payment_failed')"><div><span class="legend payment_failed"></span>Payment Failed</div><span class="sidebar-stat">{{ totals.payment_failed }}</span><div class="selected" v-if="filters.list == 'payment_failed'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('no_pos')"><div><span class="legend no_pos"></span>Web Only</div><span class="sidebar-stat">{{ totals.no_pos }}</span><div class="selected" v-if="filters.list == 'no_pos'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('range')"><div><span class="legend range"></span>Range</div><span class="sidebar-stat">{{ totals.range }}</span><div class="selected" v-if="filters.list == 'range'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('colt_connect')"><div><span class="legend colt_connect"></span>Colt Connect</div><span class="sidebar-stat">{{ totals.colt_connect }}</span><div class="selected" v-if="filters.list == 'colt_connect'"><i class="fa fa-caret-right"></i></div></div>
        <div class="sidebar-with-stat" @click="setList('ffl_office')"><div><span class="legend ffl_office"></span>FFL Office</div><span class="sidebar-stat">{{ totals.ffl_office }}</span><div class="selected" v-if="filters.list == 'ffl_office'"><i class="fa fa-caret-right"></i></div></div>

        <div class="divider"></div>

        <label>
            <span>Search Dealers</span>
            <input type="search" v-model="dealerSearchTerm">
        </label>
        <button class="primary action" @click="resetZoomAndCenter()">Reset Map</button>
    </div>
    <div style="position: relative">
        <div id="dealer_map" ref="dealer_map"></div>
        <loading class="full-page" v-if="loading"></loading>
    </div>

    <div class="modal" v-if="showDetail">
        <div class="modal-inner dealer-details">
            <i class="fas fa-times link pointer" @click="showDetail = false"></i>
            <h2>{{ locationDetail.company_name }}</h2>
            <div class="content">
                <p class="dealer-map-link">
                    <i class="fas fa-map-marker-alt" @click="zoomAndCenter(locationDetail.position)"></i>
                    <i class="fas fa-street-view" @click="goToStreetView(locationDetail.position)"></i>
                </p>
                <p>
                    {{ locationDetail.address_1 }}<br>
                    {{ locationDetail.city }}, {{ locationDetail.state }} {{ locationDetail.zip_code }}
                </p>
                <p>
                    Type: {{ locationDetail.description }}<br>
                    Start Date: {{ locationDetail.start_date }}<br>
                    FFL #: {{ locationDetail.ffl_number }}<br>
                    Phone: {{ locationDetail.phone_number }}<br>
                    Email: <a :href="'mailto:' + locationDetail.email_address">{{ locationDetail.email_address }}</a><br>
                    Website: <a :href="'http://' + locationDetail.domain_name" target="_blank">{{ locationDetail.domain_name }}</a>
                </p>
                <p>
                    <table>
                        <tr><td>YTD {{ locationDetail.client_type_code == 'FFL_OFFICE' ? 'Disposals' : 'Sales' }}:</td><td class="right">${{ locationDetail.ytd_total }}</td></tr>
                        <tr><td>Total {{ locationDetail.client_type_code == 'FFL_OFFICE' ? 'Disposals' : 'Sales' }}:</td><td class="right">${{ locationDetail.order_total }}</td></tr>
                    </table>
                </p>
            </div>
        </div>
    </div>

    <!-- <div id="dealer_map_alaska" ref="dealer_map_alaska"></div>
    <div id="dealer_map_hawaii" ref="dealer_map_hawaii"></div> -->
</div>

</template>

<script>
import gmapsInit from '@/components/maps';

export default {
    data() {
        return {
            view: 'map',
            loading: true,
            map: null,
            mapAlaska: null,
            mapHawaii: null,
            mapUSACenter: null,
            mapAlaskaCenter: null,
            mapHawaiiCenter: null,
            mapUSAZoom: 5,
            mapAlaskaZoom: 3,
            mapHawaiiZoom: 7,
            totals: {},
            filters: {
                list: 'all'
            },
            dealerSearchTerm: null,
            markerColors: {
                all: "rgba(51, 104, 154, 1)",
                full_cds: "rgba(51, 65, 154, 1)",
                ffl_office: "rgba(74, 189, 172, 1)",
                colt_connect: "rgba(0, 10, 50, 1)",
                no_pos: "rgba(145, 29, 149, 1)",
                range: "rgba(90, 24, 209, 1)",
                payment_failed: "rgba(200, 44, 44, 1)"
            },
            locations: [],
            markers: [],
            infoWindows: [],
            loadingDetail: false,
            showDetail: false,
            locationDetail: {
                title: '',
                address_1: '',
                city: '',
                zip_code: '',
                state: ''
            }
        }
    },
    async mounted() {
        try {
            const google = await gmapsInit();
            this.mapUSACenter = new google.maps.LatLng(39.8097343, -98.5556199)
            // mapId tells Google maps that we have a style associated with a particular map ID in the google maps dashboard
            // To edit styles go here: https://console.cloud.google.com/google/maps-apis/client-styles?project=cds-dealer-map
            var mapOptions = {
                mapId: 'e787f5684c9e233a',
                center: this.mapUSACenter,
                zoom: this.mapUSAZoom,
                mapTypeControl: false,
                rotateControl: false,
                fullscreenControl: false
            }
            var mapDiv = document.getElementById('dealer_map')
            this.map = new google.maps.Map(mapDiv, mapOptions);
            
            // No separate Alaska or Hawaii maps for now
            // this.mapAlaskaCenter = new google.maps.LatLng(66.160507, -153.369141)
            // this.mapHawaiiCenter = new google.maps.LatLng(20.348289495822392, -157.63173543876525)
            // var mapAlaskaDiv = document.getElementById('dealer_map_alaska')
            // var mapHawaiiDiv = document.getElementById('dealer_map_hawaii')
            // mapOptions.zoom = this.mapAlaskaZoom
            // mapOptions.center = this.mapAlaskaCenter
            // this.mapAlaska = new google.maps.Map(mapAlaskaDiv, mapOptions);
            // mapOptions.zoom = this.mapHawaiiZoom
            // mapOptions.center = this.mapHawaiiCenter
            // this.mapHawaii = new google.maps.Map(mapHawaiiDiv, mapOptions);
            
            this.fetchData()
            this.getTotals()
        } catch (error) {
            console.error(error);
        }
    },
    watch: {
        async dealerSearchTerm(newVal) {
            this.loading = true
            if (!newVal) this.showAllMarkers()
            else {
                await this.markers.forEach(marker => {
                    if (marker.title.toLowerCase().indexOf(this.dealerSearchTerm.toLowerCase()) > -1) {
                        marker.setMap(this.map)
                    } else {
                        marker.setMap(null)
                    }
                })
            }
            this.loading = false
        }
    },
    methods: {
        fetchData() {
            this.loading = true
            this.hideAllMarkers()
            this.markers = []
            this.apiCall({ destination: 'get_list_dealer_map_locations', data: { filters: this.filters }}).then(async obj => {
                const svgMarker = {
                    path:
                    "M 5, 10 a 5,5 0 1,1 10,0 a 5,5 0 1,1 -10,0",
                    fillColor: this.markerColors[this.filters.list],
                    fillOpacity: 1.0,
                    strokeWeight: 0,
                    rotation: 0,
                    scale: 1.5
                };
                this.locations = obj.locations
                await this.locations.forEach(location => {
                    let marker = new google.maps.Marker({ ...location, icon: svgMarker, map: this.map })
                    let contentString = `<div id="content><div id="bodyContent">${location.title}</div></div>`
                    const infoWindow = new google.maps.InfoWindow({
                        content: contentString,
                    });
                    marker.addListener("click", () => {
                        this.getLocation(location.client_id)
                    });
                    marker.addListener("mouseover", () => infoWindow.open(this.map, marker))
                    marker.addListener("mouseout", () => infoWindow.close())
                    this.markers.push(marker)
                })
                this.loading = false
            }).catch(err => {
                this.loading = false
                console.log(err);
            })
        },
        getTotals() {
			this.apiCall({ destination: 'get_totals' }).then(obj => {
				this.totals = obj.totals
			}).catch(err => {
				console.log(err)
			})
		},
        getLocation(clientId) {
			if (this.loadingDetail) {
				return
			}
			this.loadingDetail = true
			this.apiCall({ destination: 'get_dealer_details', data: { client_id: clientId }}).then(obj => {
				this.locationDetail = obj.detail
                this.showDetail = true
				this.loadingDetail = false
			}).catch(err => {
				console.log(err)
			})
		},
        setList(list) {
            this.filters.list = list
            this.fetchData()
        },
        zoomAndCenter(position) {
            this.map.setCenter(new google.maps.LatLng(position.lat, position.lng))
            this.map.setZoom(12)
            this.showDetail = false
        },
        goToStreetView(location) {
            let panorama = this.map.getStreetView()
            panorama.setPosition(location)
            panorama.setVisible(true)
            this.showDetail = false
        },
        async hideAllMarkers() {
            if (this.markers.length == 0) return
            await this.markers.forEach(marker => marker.setMap(null))
        },
        async showAllMarkers() {
            if (this.markers.length == 0) return
            await this.markers.forEach(marker => marker.setMap(this.map))
        },
        resetZoomAndCenter() {
            this.dealerSearchTerm = null
            this.map.setZoom(this.mapUSAZoom)
            this.map.setCenter(this.mapUSACenter)
            // this.mapAlaska.setZoom(this.mapAlaskaZoom)
            // this.mapAlaska.setCenter(this.mapAlaskaCenter)
        }
    }
}
</script>

<style lang="scss">
.dealer-map {
    display: grid;
    grid-template-columns: 1fr 80%;
    position: relative;

    .loading.full-page {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100% !important;
    }

    .sidebar-with-stat {
        position: relative;
        display: grid;
        grid-template-columns: 2fr 1fr 15px;
        align-items: center;
        grid-gap: 6px;
        line-height: 1.5em;
        padding: 0.25em;
    }
    .sidebar-with-stat:hover {
        background-color: #e4e4e4;
        cursor: pointer;
    }
    .sidebar-stat {
        text-align: right;
    }
    .legend { display: inline-block; height: 0.8em; width: 0.8em; margin: 0 0.25em 0 0; }
    .all { background-color: rgba(51, 104, 154, 1); }
    .full_cds { background-color: rgba(51, 65, 154, 1); }
    .ffl_office { background-color: rgba(74, 189, 172, 1); }
    .colt_connect { background-color: rgba(0, 10, 50, 1); }
    .no_pos { background-color: rgba(145, 29, 149, 1); }
    .range { background-color: rgba(90, 24, 209, 1); }
    .payment_failed { background-color: rgba(200, 44, 44, 1); }
    i.fa { color: #666; height: 15px; margin-top: -5px; }
    .selected { font-size: 2em; justify-self: right; }
    .divider { margin: 1em 0; }
    .sidebar button { cursor: pointer; }
    .sidebar button:disabled { cursor: not-allowed; }
    .dealer-list { width: 100%; margin: 0 0 0 2em;text-align: left; }
    .dealer-list td:first-of-type { width: 25%; }
}
#dealer_map {
    width: 100%;
    height: 900px;
}
#dealer_map_alaska {
    height: 20em;
    width: 20em;
}
#dealer_map_hawaii {
    height: 25em;
    width: 35em;
}
.dealer-details {
    // z-index: 999;
    // position: fixed;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // margin: auto;
    // width: 33em;
    // max-width: 90%;
    // height: 25em;
    // max-height: 90%;
    // border: 1px solid #999;
    // background-color: #fff;
    // border-radius: 0.5em;
    // -webkit-box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.3);
    // -moz-box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.3);
    // box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.3);

    // .heading {
    //     background-color: #33689a;
    //     color: #fff;
    //     padding: 0.5em 0 0.4em 0.66em;
    //     font-weight: bold;
    //     border-top-right-radius: 0.4em;
    //     border-top-left-radius: 0.4em;
    //     text-transform: uppercase;
    // }
    padding: 0;
    background: white;
    position: absolute;
    top: 25%;

    .content {
        overflow-x: auto !important;
    }

    i.fa-times {
        position: absolute;
        right: -8px;
        top: -9px;
        background: black;
        border-radius: 100%;
        color: white;
        padding: 2px;
        width: 15px;
        text-align: center;
    }

    h2 {
        background: none;
        margin-left: 0;
        padding-left: 0;
    }


    p {
        margin: 0 0 1em 0;
        padding: 0;
    }

    a {
        color: #000;
    }

    table {
        width: 90%;
    }

    p.dealer-address {
        float: left;
    }
    p.dealer-map-link {
        float: right;
        font-size: 1.8em;
    }
    .fa-map-marker-alt { color: #ea4336; }
    .fa-street-view { color: #fdbf2d; }

    p.dealer-address {
        width: 70%;
    }
}
</style>